(function () {
  'use strict';

  var BTN = '[data-admyre-qf-btn]';
  var CONTAINER = '[data-admyre-quick-filter]';
  var ACTIVE = 'is-active';
  var LOADING = 'is-loading';

  var GRID = '[data-products-grid]';
  var SIDEBAR = '[data-collection-sidebar]';
  var NAV = '[data-collection-nav]';
  var SECTION = '[data-section-id]';
  var RESULTS = '[data-results-count]';
  var COUNT_ATTR = 'data-active-filters-count';
  var COUNT_SEL = '[data-active-filters]';

  document.addEventListener('click', function (e) {
    var btn = e.target.closest(BTN);
    if (!btn || btn.disabled) return;

    var paramName = btn.dataset.paramName;
    var paramValue = btn.dataset.paramValue;
    var isActive = btn.classList.contains(ACTIVE);

    var url = new URL(window.location.href);
    var params = url.searchParams;

    if (isActive) {
      var existing = params.getAll(paramName);
      params.delete(paramName);
      existing.forEach(function (v) {
        if (v !== paramValue) params.append(paramName, v);
      });
    } else {
      params.append(paramName, paramValue);
    }

    params.delete('page');

    var newUrl = params.toString()
      ? url.pathname + '?' + params.toString()
      : url.pathname;

    window.history.pushState(null, '', newUrl);

    btn.classList.toggle(ACTIVE);
    btn.setAttribute('aria-pressed', String(!isActive));

    fetchAndUpdate(btn.closest(SECTION));
  });

  function fetchAndUpdate(section) {
    if (!section) return;

    var grid = section.querySelector(GRID);
    var sidebar = section.querySelector(SIDEBAR);
    var nav = section.querySelector(NAV);
    var resultsCount = section.querySelector(RESULTS);

    if (grid) grid.classList.add(LOADING);

    fetch(window.location.pathname + window.location.search)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');

        var newGrid = doc.querySelector(GRID);
        if (grid && newGrid) grid.innerHTML = newGrid.innerHTML;

        if (sidebar) {
          var newSidebar = doc.querySelector(SIDEBAR);
          if (newSidebar) sidebar.innerHTML = newSidebar.innerHTML;

          var countSource = sidebar.querySelector('[' + COUNT_ATTR + ']');
          var badges = section.querySelectorAll(COUNT_SEL);
          if (countSource && badges.length) {
            var count = parseInt(countSource.getAttribute(COUNT_ATTR), 10);
            badges.forEach(function (el) {
              el.textContent = count;
              el.classList.toggle('hidden', count < 1);
            });
          }
        }

        if (resultsCount) {
          var newCount = doc.querySelector(RESULTS);
          if (newCount) resultsCount.innerHTML = newCount.innerHTML;
        }

        var quickFilter = section.querySelector(CONTAINER);
        var newQuickFilter = doc.querySelector(CONTAINER);
        if (quickFilter && newQuickFilter) {
          quickFilter.innerHTML = newQuickFilter.innerHTML;
        }

        if (nav && grid && window.theme && window.theme.scrollTo) {
          window.theme.scrollTo(
            grid.getBoundingClientRect().top - nav.offsetHeight
          );
        }

        setTimeout(function () {
          if (grid) grid.classList.remove(LOADING);
        }, 500);
      })
      .catch(function (err) {
        console.error('[admyre-quick-filter]', err);
        if (grid) grid.classList.remove(LOADING);
      });
  }

  // Sync button states when filters change via sidebar or browser navigation
  var _pushState = history.pushState;

  history.pushState = function () {
    _pushState.apply(history, arguments);
    syncButtonStates();
  };

  window.addEventListener('popstate', function () {
    syncButtonStates();
  });

  function syncButtonStates() {
    var params = new URLSearchParams(window.location.search);
    var buttons = document.querySelectorAll(BTN);

    buttons.forEach(function (btn) {
      var values = params.getAll(btn.dataset.paramName);
      var active = values.indexOf(btn.dataset.paramValue) !== -1;
      btn.classList.toggle(ACTIVE, active);
      btn.setAttribute('aria-pressed', String(active));
    });
  }
})();
